// extracted by mini-css-extract-plugin
export default {"delete":"DeleteModal_delete__fjMTJ","dark":"DeleteModal_dark__mIOz9","cancelBtn":"DeleteModal_cancelBtn__7eF5J","deleteBtn":"DeleteModal_deleteBtn__81KNs"};